module.exports = __webpack_public_path__ + "static/media/avoid-contacts.d5a6fadb.svg";